import { render, staticRenderFns } from "./website-faqs.vue?vue&type=template&id=22dd92a8&scoped=true"
import script from "./website-faqs.vue?vue&type=script&lang=js"
export * from "./website-faqs.vue?vue&type=script&lang=js"
import style0 from "./website-faqs.vue?vue&type=style&index=0&id=22dd92a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd92a8",
  null
  
)

export default component.exports